var arr = [];

//  sort the date tags
$('.collection__main product-list product-card').each(function(){    
	arr.push($(this).attr('data-mili'));  
    // console.log("ddd");
});

//==== sordt the div on the basis of date 
arr.sort(function(a, b){return b-a});
var result = $('.collection__main product-list product-card').sort(function (a, b) {  
  var contentA = parseInt( $(a).attr('data-mili'));
  var contentB = parseInt( $(b).attr('data-mili'));
  return (contentA > contentB) ? -1 : (contentA < contentB) ? 1 : 0;

});

$('.collection__main product-list').html(result);